import { call, put, takeLatest } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage, mergeFollowUpSavePayload } from './helpers';

function* followUpCreate({ payload: { auditId, data, companyId } }) {
  try {
    const { data: response } = yield call(dataProvider.createOne, `audit/follow-up/${auditId}`, data);
    const followUp = mergeFollowUpSavePayload((response && response.data) || response || null, {
      ...data,
      auditId,
    });
    yield put({
      type: psmAuditDigital.followUpCreate.end,
      payload: followUp,
    });
    yield put({ type: notification.add, payload: { success: 'Follow-up saved successfully' } });
    if (companyId) {
      yield put({ type: psmAuditDigital.list.start, payload: { companyId } });
    }
    if (data.status === 'Completed' && companyId) {
      yield put({ type: psmAuditDigital.pendingCompanyRedirectSet, payload: { companyId } });
    }
  } catch (e) {
    yield put({ type: psmAuditDigital.followUpCreate.error });
    yield put({
      type: notification.add,
      payload: { error: getNotificationErrorMessage(e, 'Failed to save follow-up') },
    });
  }
}

export default function* followUpCreateSaga() {
  yield takeLatest(psmAuditDigital.followUpCreate.start, followUpCreate);
}
